import cx from 'classnames';
import React, { useState, useRef, useLayoutEffect } from 'react';
import { CSSTransition } from 'react-transition-group';
import { withNativeProps } from '../../utils/native-props';
import { mergeProps } from '../../utils/with-default-props';
import { useLockScroll } from '../../utils/use-lock-scroll';
import { renderToContainer } from '../../utils/render-to-container';
import { ShouldRender } from '../../utils/should-render';
import { useDeferredVisible } from '../../utils/use-deferred-visible';
import Mask from '../mask';
var classPrefix = 'nib-popup';
var defaultProps = {
  visible: false,
  position: 'bottom',
  mask: true,
  destroyOnClose: false,
  forceRender: false,
  getContainer: function getContainer() {
    return document.body;
  },
  disableBodyScroll: true,
  enterTimeout: 300,
  exitTimeout: 200,
  enterTimingFunction: 'ease-in-out',
  exitTimingFunction: 'ease-in-out'
};
export var Popup = function Popup(p) {
  var _cx;

  var props = mergeProps(defaultProps, p);

  var _useState = useState(props.visible),
      active = _useState[0],
      setActive = _useState[1];

  var deferredVisible = useDeferredVisible(props.visible && active);
  useLayoutEffect(function () {
    if (props.visible) {
      setActive(true);
    }
  }, [props.visible]);

  var afterClose = function afterClose() {
    var _a;

    setActive(false);
    (_a = props.afterClose) === null || _a === void 0 ? void 0 : _a.call(props);
  };

  var bodyClassName = cx(classPrefix + "-body", classPrefix + "-body-position-" + props.position, (_cx = {}, _cx[classPrefix + "-body-hidden"] = !props.visible, _cx), props.bodyClassName);
  var ref = useRef(null);
  useLockScroll(ref, props.disableBodyScroll && active);
  var node = withNativeProps(props, /*#__PURE__*/React.createElement("div", {
    className: classPrefix,
    style: {
      'display': active ? undefined : 'none',
      // @ts-ignore
      '--enter-timeout': props.enterTimeout + "ms",
      '--enter-timing-function': props.enterTimingFunction,
      '--exit-timeout': props.exitTimeout + "ms",
      '--exit-timing-function': props.exitTimingFunction
    },
    onClick: props.onClick
  }, props.mask && /*#__PURE__*/React.createElement(Mask, {
    visible: deferredVisible,
    forceRender: props.forceRender,
    destroyOnClose: props.destroyOnClose,
    onMaskClick: props.onMaskClick,
    className: props.maskClassName,
    style: props.maskStyle,
    enterTimeout: 100,
    exitTimeout: 100,
    disableBodyScroll: false
  }), /*#__PURE__*/React.createElement(CSSTransition, {
    nodeRef: ref,
    in: deferredVisible,
    timeout: {
      enter: props.enterTimeout,
      exit: props.exitTimeout
    },
    classNames: classPrefix + "-body",
    onEntered: props.afterShow,
    onExited: afterClose,
    unmountOnExit: props.destroyOnClose
  }, /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: bodyClassName,
    style: props.bodyStyle
  }, props.children))));
  return /*#__PURE__*/React.createElement(ShouldRender, {
    active: active,
    forceRender: props.forceRender,
    destroyOnClose: props.destroyOnClose
  }, renderToContainer(props.getContainer, node));
};